module.exports = __webpack_public_path__ + "static/media/settings-small.0f3f64b0.png";